// Paths of the AVM API

import type {RevaIndicationEndpoint} from "@reva/shared/spec-conversion";

export const PATH_GEOREF = "/v1/georef";

export const PATH_LOCATIONINFO = "/v1/locationInformation";
export const PATH_TIMELINES_DOCUMENTATION = "/v1/locationInformation/timelines/documentation";
export const PATH_VALUE_INDICATION = "/v1/indicate/value";
export const PATH_AVM_DOCUMENTATION = "/v1/documentation";
export const PATH_AVM_RELEASENOTES = "/v1/releasenotes";
/** Liste aller Dokumentationen der AVM-API mit Upload-Datum, ohne Datei-Inhalt (#19302). */
export const PATH_AVM_DOCUMENTATION_LIST = "/v1/documentation/list";
/** Parameterübersicht der AVM-API (#19302), Query-Parameter `language` (`de`/`en`, ohne Angabe `en`). */
export const PATH_AVM_PARAMETERS = "/v1/parameters";
/** Validierungsbericht der AVM-Modelle (#19302). */
export const PATH_AVM_VALIDATION_REPORT = "/v1/validation";
/** Methodenbeschreibung der Wohnlagen (Mikro-/Makrolage, #19302); nur mit dem Recht `location-micromacro`. */
export const PATH_MICRO_MACRO_DOCUMENTATION = "/v1/locationInformation/microMacro/documentation";

/**
 * Endpunkte, zu denen die AVM-API eine Methodenbeschreibung ausliefert: die REVA-Tabellen-Endpunkte
 * plus der Vergleichspreis, der in REVA keine eigene Seite hat, aber in den Konvergenzwert einfließt.
 */
export type AvmDocumentedEndpoint = RevaIndicationEndpoint | "COMPARATIVE_PRICE";

/**
 * Verfahrensspezifische Methodenbeschreibung je Indikations-Endpunkt (#19432). Die AVM-API hängt
 * `/documentation` an den jeweiligen Endpunkt-Pfad und liefert das PDF nur aus, wenn die Lizenz den
 * Endpunkt selbst freigibt (sonst 403).
 */
export const PATH_INDICATION_DOCUMENTATION: Record<AvmDocumentedEndpoint, string> = {
    VALUE: `${PATH_VALUE_INDICATION}/documentation`,
    COMPARATIVE_PRICE: "/v1/indicate/comparativePrice/documentation",
    COMPARATIVE_VALUE: "/v1/indicate/comparativeValue/documentation",
    REAL_ASSET_VALUE: "/v1/indicate/realAssetValue/documentation",
    INCOME_VALUE: "/v1/indicate/incomeValue/documentation",
    ENERGY_VALUE: "/v1/indicate/energyValue/documentation",
};

export const PATH_QUALITY_FURNISHINGS = "/v1/objectInformation/qualityFurnishings";
export const PATH_MODERNIZATION_DEGREE = "/v1/objectInformation/modernizationDegree";

// is not part of the REVA API, but of the AVM API due to technical reasons
export const PATH_REVA_SPEC = "/reva/indication/spec";

/** REVA-Anwenderhandbuch je Zweck (#19302), Query-Parameter `purpose` und `language`. Liegt aus demselben Grund in der AVM-API. */
export const PATH_REVA_MANUAL = "/reva/manual";
